'use memo';

import { useAppSelector } from 'hooks/useAppSelector';
import { LoadingState } from 'utils/loadingState';
import ReportingDashboard from './reportingDashboard';

const ReportingDashboardRoute = () => {
  const { loadingState } = useAppSelector(state => state.agencies.agencyInfo);

  if (loadingState !== LoadingState.Loaded) return null;

  return <ReportingDashboard />;
};

export default ReportingDashboardRoute;
